<template>
  <v-content>
    <section>
      <v-parallax 
        :src="require('@/assets/images/screen_04.jpg')" 
        height="300"
      >
        <v-layout
          column
          align-center
          justify-center
        >
          <h1 class="h_first_line">
            {{ $t('h_about_head_01') }}
          </h1>
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-layout
        column
        wrap
        class="my-5"
        align-center
      >
        <v-flex 
          xs10 
          sm4 
          class="my-3"
        >
          <v-card 
            class="elevation-0 transparent"
          >
            <v-card-text 
              class="layout justify-center"
            >
              <v-icon 
                x-large 
                class="blue--text text--lighten-2"
              >
                fa-user-tie
              </v-icon>
            </v-card-text>

            <v-expansion-panels focusable>
              <v-expansion-panel class="elevation-0 transparent">
                <v-expansion-panel-header class="p_text">
                  {{ $t('my_about') }} 
                  </v-expansion-panel-header>
                <v-expansion-panel-content class="p_text">
                  <v-divider></v-divider>
                  {{ $t('my_about_01') }}
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>
        </v-flex>
      </v-layout>
    </section>

    <section class="hidden-md-and-up">
      <v-container grid-list-xl>
        <v-layout 
          row 
          wrap 
          justify-center 
          class="my-5"
        >
          <v-flex 
            xs12 
            sm4
          >
            <div>
              <road-map-list></road-map-list>
            </div>
          </v-flex>
          <v-flex 
            xs12 
            sm4 
            offset-sm1
          >
            <div>
              <progress-list></progress-list>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section class="hidden-sm-and-down">
      <v-layout
        row
        wrap
        class="my-5"
        align-center
      >
        <v-flex 
          xs12
        >
          <v-container 
            grid-list-xl
          >
            <v-layout 
              row 
              wrap 
              align-top
            >
              <v-flex 
                xs6
                md6
              >
                <div>
                  <road-map-list></road-map-list>
                </div>
              </v-flex>

              <v-flex 
                xs6 
                md6
              >
                <div>
                  <progress-list></progress-list>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>

    <section class="hidden-md-and-up">
      <v-container grid-list-xl>
        <v-layout 
          row 
          wrap 
          justify-center 
          class="my-5"
        >
          <v-flex 
            xs12 
            sm4
          >
            <div>
              <certificate-list></certificate-list>
            </div>
          </v-flex>
          <v-flex 
            xs12 
            sm4 
            offset-sm1
          >
            <div>
              <hobby-list></hobby-list>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section class="hidden-sm-and-down">
      <v-container grid-list-xl>
        <v-layout 
          row 
          wrap 
          justify-center 
          class="my-5"
        >
          <v-flex 
            xs6 
            md6
          >
            <div>
              <certificate-list></certificate-list>
            </div>
          </v-flex>
          <v-flex 
            xs6 
            md6 
          >
            <div>
              <hobby-list></hobby-list>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </v-content>
</template>

<script>
  // import RoadMapList     from '@/components/RoadMapList'
  // import ProgressList    from '@/components/ProgressList'
  // import CertificateList from '@/components/CertificateList'
  // import HobbyList       from '@/components/HobbyList'
  const RoadMapList     = () => import('@/components/RoadMapList');
  const ProgressList    = () => import('@/components/ProgressList');
  const CertificateList = () => import('@/components/CertificateList');
  const HobbyList       = () => import('@/components/HobbyList');
  export default {
    components:{
      RoadMapList,
      ProgressList,
      CertificateList,
      HobbyList
    }
  }
</script>

<style lang="scss" scoped>

</style>
